export default __webpack_public_path__ + "4bede76156e2b758791027e0e9063c2f.png";